import React, { createContext, useState, useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import api from '@utils/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children, serverLanguage, initialUser }) => {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(initialUser);
  const [loading, setLoading] = useState(true);
  const [isPremium, setIsPremium] = useState(initialUser?.have_active_credit);

  useEffect(() => {
    // 1️⃣ Get token from URL
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");


    if (token) {
      localStorage.setItem("access_token_chart", token)

      // 3️⃣ Remove token from URL
      params.delete("token");
      const newUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
      window.history.replaceState({}, "", newUrl);
    }
  }, []);




  // -------------------- LOGIN --------------------
  const login = async (user) => {
    setIsAuthenticated(true)
    setLoading(false)
    setUser(user)
  };

  // -------------------- LOGOUT -------------------


  // -------------------- INIT AUTH (Middleware) --------------------
  const initAuth = async () => {


    try {

      const data = await api.get('/me')
        .then(data => data.data)

      if (data?.user_email || data?.user_login) {

        login(data);
      }






    } catch (e) {

        window.location.href = 'https://tablokhani.com/';

      console.log("Not logged in", e);
    }
  };

  useEffect(() => {
    initAuth();



  }, []);







  const logout = () => {

    setUser({});
    setIsAuthenticated(false);
    window.location.href = "https://tablokhani.com";

  };

  const contextValue = useMemo(() => ({
    user,
    login,
    isPremium,
    setIsPremium,
    logout,
    isAuthenticated
  }), [user, login, isPremium, setIsPremium, isAuthenticated]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};
